const dialog    = require ('../../../../../components/dialog/dialog')

export function start( detail ){

	dialogBody[detail.id].start() 
	
	detail.html =  dialogBody[detail.id]
	dialog.start(detail)

}

const dialogBody = {

	emailStatusInfo: {
		title: 'Email status information', des: '', bodyHtml: '',
		primary: {
			text: 'Close', class: 'button primary',
			dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'`,
		},
		secondary: { text: '', class: 'button secondary button-plain', dataDetail: '' },
		tertiary: { text: '', class: 'button secondary button-plain', dataDetail: '' },
		start: function () {
			this.bodyHtml = `
				<div class="des">
					<div class="font-body2 mb-16">These statuses show the current delivery state reported by the email service.</div>
					<div class="mb-16"><div class="font-body2-b">PENDING</div><div class="font-body2 mt-8">The email was registered and is waiting for a delivery update.</div></div>
					<div class="mb-16"><div class="font-body2-b">SENT</div><div class="font-body2 mt-8">The recipient's email server accepted the message.</div></div>
					<div class="mb-16"><div class="font-body2-b">SPAM</div><div class="font-body2 mt-8">The recipient reported the message as unwanted email.</div></div>
					<div class="mb-16"><div class="font-body2-b">BOUNCE</div><div class="font-body2 mt-8">The message was rejected or could not be delivered to the recipient.</div></div>
					<div><div class="font-body2-b">BLOCKED</div><div class="font-body2 mt-8">The email service stopped the message before delivery.</div></div>
				</div>`
		},
	},

	hellow: { 
		title:  '',
		des: '',
		bodyHtml:`

				<div class="textfield textfield-filled  textfield-autocomplete" id="_______">

				  <input  class= 'elem' type="text"   value="empy1" 
				         data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' >

				  <div class="indicador"></div>

				  <div class="trailing"  data-detail='{"click": [{"dest":"textfield", "act":"clear"}] }' >
				    <svg><use xlink:href="../../../public/css/svg.svg#cancel"></use></svg>
				  </div>

				  <div class="label">text</div> 
				  <div class="helper" >Required*</div>
				  <div class="counter">10/10</div> 
				  <div class="selector"></div>
				</div><!-- textfield -->  


				<div class="textfield textfield-filled  textfield-autocomplete" id="_______">

				  <input  class= 'elem' type="text"   value="empy1" 
				         data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' >

				  <div class="indicador"></div>

				  <div class="trailing"  data-detail='{"click": [{"dest":"textfield", "act":"clear"}] }' >
				    <svg><use xlink:href="../../../public/css/svg.svg#cancel"></use></svg>
				  </div>

				  <div class="label">text</div> 
				  <div class="helper" >Required*</div>
				  <div class="counter">10/10</div> 
				  <div class="selector"></div>
				</div><!-- textfield -->  

		`,

		primary: {
			text:'',
			class:'button primary',
	        dataDetail:`data-detail='{
	                        "click": [
	                            {"dest":"ripple" },
	                            {"dest":"dialog", "act":"hide"} ]}'`,
		},

		secondary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:`data-detail='{ "click": [ {"dest":"ripple" },  {"dest":"dialog", "act":"hide"} ]}'`,
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:`data-detail='{  "click": [ {"dest":"ripple" },  {"dest":"dialog", "act":"hide"} ]}'`,
		},      

		start: function(){
			this.title     = 'TEST title'
			this.des       = ''
			this.primary.text   = 'TEST 111'
			this.secondary.text = 'TEST 222'						
			this.tertiary.text  = 'TEST 33333'						
		}

	},
	
}



